<template>
  <div>
    <v-card class="elevation-1 my-4">
      <v-card flat class="elevation-0 pb-2">
        <v-card-title class="py-2">
          <span class="primary--text text--capitalize"
            >Application Settings</span
          >
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            small
            v-show="editMode"
            depressed
            color="error"
            @click="cancel()"
          >
            <v-icon small class="pr-2">mdi-undo</v-icon>Cancel
          </v-btn>
          <v-btn
            :flat="!editMode"
            dark
            small
            :color="editMode ? 'ctcGreen' : 'primary'"
            depressed
            @click="editMode ? save() : (editMode = true)"
          >
            <v-icon small class="pr-2">{{ editMode ? "save" : "edit" }}</v-icon>
            {{ editMode ? "Save" : "Edit" }}
          </v-btn>
        </v-card-title>
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">settings</v-icon
              >Company Type:
            </span>
          </v-flex>

          <v-flex xs5>
            <v-radio-group
              height="24"
              hide-details
              row
              class="mt-0 pt-0"
              v-model="companyTypeIndex"
            >
              <v-radio
                :disabled="!editMode"
                height="24"
                color="amber darken1"
                label="Supplier"
                :value="0"
              ></v-radio>
              <v-radio
                :disabled="!editMode"
                height="24"
                color="blue"
                label="Customer"
                :value="1"
              ></v-radio>
              <v-radio
                :disabled="!editMode"
                height="24"
                color="purple"
                label="Subsidiary"
                :value="2"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <!-- Alert when no type is selected -->
        <v-layout justify-center px-4 py-2 wrap v-if="companyType == ''">
          <v-alert style="width: 100%;" :value="true" type="error"
            >This company does not have a company type associated to it. You
            need to choose one before you can manage the company
            settings.</v-alert
          >
        </v-layout>
      </v-card>

      <template v-if="companyType != 'subsidiary' && companyType != ''">
        <v-card
          flat
          class="elevation-0 pb-2"
          v-for="category in Object.keys(settings[companyType])"
          :key="category"
          v-show="
            settings[companyType][category].filter((e) =>
              displayModel(e.isFieldNeeded)
            ).length
          "
        >
          <v-card-title class="py-2">
            <span class="primary--text text--capitalize">{{ category }}</span>
          </v-card-title>

          <template v-for="(model, index) in settings[companyType][category]">
            <v-layout
              my-2
              align-center
              :key="model.label"
              v-if="displayModel(model.isFieldNeeded)"
            >
              <v-flex xs5 offset-xs1>
                <span style="color: #757575;">
                  <v-icon small class="pr-1" color="#757575">{{
                    model.icon
                  }}</v-icon>
                  {{ model.label }}:
                </span>
              </v-flex>

              <v-flex :xs5="editMode" :xs6="!editMode">
                <v-autocomplete
                  v-if="model.type == 'autocomplete' && editMode"
                  :items="model.items[0]"
                  :item-value="model.items[1]"
                  :item-text="model.items[2]"
                  v-model="tempCompany[companyType][model.value]"
                  hide-details
                  solo
                  flat
                  dense
                  :chips="model.chips"
                  :multiple="model.multiple"
                  :label="
                    model.alternate_label ? model.alternate_label : model.label
                  "
                  single-line
                  class="dense-input"
                  background-color="#f4f4f4"
                  browser-autocomplete="noautocomplete"
                >
                  <v-tooltip v-if="model.tooltipHtml" slot="append" bottom>
                    <v-icon
                      slot="activator"
                      class="help_icon"
                      style="
                        position: relative !important;
                        top: 0px !important;
                        left: 0px !important;
                      "
                      dark
                      >help</v-icon
                    >
                    <span v-html="model.tooltipHtml" />
                  </v-tooltip>

                  <template
                    v-slot:selection="{ item, index }"
                    v-if="model.chips"
                  >
                    <v-chip v-if="index < 2">
                      <span>{{ truncate(item[model.items[2]], 36) }}</span>
                    </v-chip>
                    <span v-if="index === 2" class="grey--text caption"
                      >(+{{
                        tempCompany[companyType][model.value].length - 2
                      }}
                      others)</span
                    >
                  </template>
                </v-autocomplete>

                <template
                  v-if="
                    model.type == 'autocomplete' &&
                    !editMode &&
                    Array.isArray(tempCompany[companyType][model.value])
                  "
                >
                  <v-label
                    v-for="item in tempCompany[companyType][model.value]"
                    :key="item"
                  >
                    <v-chip text-color="#444">{{
                      truncate(getNameById(item, model.items[3]), 36)
                    }}</v-chip>
                  </v-label>
                </template>

                <template
                  v-if="
                    model.type == 'autocomplete' &&
                    !editMode &&
                    !Array.isArray(tempCompany[companyType][model.value])
                  "
                >
                  <v-label>
                    <v-chip text-color="#444">{{
                      getNameById(
                        tempCompany[companyType][model.value],
                        model.items[3]
                      )
                    }}</v-chip>
                  </v-label>
                </template>

                <v-text-field
                  v-if="model.type == 'textfield' && editMode"
                  flat
                  hide-details
                  solo
                  single-line
                  :label="
                    model.alternate_label ? model.alternate_label : model.label
                  "
                  class="dense-input"
                  background-color="#f4f4f4"
                  v-model="tempCompany[companyType][model.value]"
                >
                  <v-tooltip v-if="model.tooltipHtml" slot="append" bottom>
                    <v-icon
                      slot="activator"
                      class="help_icon"
                      style="
                        position: relative !important;
                        top: 0px !important;
                        left: 0px !important;
                      "
                      dark
                      >help</v-icon
                    >
                    <span v-html="model.tooltipHtml" />
                  </v-tooltip>
                </v-text-field>
                <span v-if="model.type == 'textfield' && !editMode">{{
                  tempCompany[companyType][model.value]
                }}</span>
              </v-flex>
            </v-layout>
            <v-flex
              class="px-5"
              :key="'divider_' + index"
              v-if="
                index != settings[companyType][category].length - 1 &&
                displayModel(model.isFieldNeeded)
              "
            >
              <v-divider />
            </v-flex>
          </template>
        </v-card>
      </template>
    </v-card>

    <!-- Supplier Additionnal Informations -->
    <v-layout
      justify-center
      wrap
      v-if="tempCompany.isSupplier && !newCompany.isSupplier"
    >
      <v-alert style="width: 100%;" :value="true" type="info">
        You need to save this company as a
        <strong>supplier</strong> in order to beeing able to access
        <strong>documentary instructions settings</strong>
      </v-alert>
    </v-layout>
    <v-expansion-panel
      v-if="tempCompany.isSupplier && newCompany.isSupplier"
      class="expandPanel mt-4"
      expand
      v-model="ai_expanded"
    >
      <v-expansion-panel-content>
        <div slot="header">Select defaults additionnal informations</div>
        <v-flex xs12 sm12 md12 xl12 px-4 pt-2>
          <v-card flat>
            <integratedSearchBar
              :button_display="false"
              v-bind:search.sync="ai_search"
              search_label="Search additionnal information..."
            />
            <v-data-table
              :headers="ai_headers"
              hide-headers
              id="supplier_additional_informations"
              :items="additionalInformations"
              :search="ai_search"
              :pagination.sync="ai_pagination"
              must-sort
              rows-per-page-text="Additionnal Informations per page"
            >
              <v-progress-linear
                slot="progress"
                color="blue"
                indeterminate
              ></v-progress-linear>
              <template slot="items" slot-scope="info">
                <v-flex
                  pt-3
                  style="cursor: pointer;"
                  @click="
                    aiUpdate(
                      info.item.id,
                      !newCompany.supplier.additional_information_ids.includes(
                        info.item.id
                      )
                    )
                  "
                >
                  <v-checkbox
                    ripple
                    flat
                    height="8"
                    :label="info.item.name"
                    :input-value="
                      newCompany.supplier.additional_information_ids.includes(
                        info.item.id
                      )
                    "
                  ></v-checkbox>
                </v-flex>
                <v-divider></v-divider>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- Customer Documentary Instructions -->
    <v-layout
      justify-center
      wrap
      v-if="tempCompany.isCustomer && !newCompany.isCustomer"
    >
      <v-alert style="width: 100%;" :value="true" type="info">
        You need to save this company as a
        <strong>customer</strong> in order to beeing able to access
        <strong>documentary instructions settings</strong> and
        <strong>customer parameters</strong>
      </v-alert>
    </v-layout>
    <!-- Customer Parameters -->
    <v-expansion-panel
      v-if="tempCompany.isCustomer && newCompany.isCustomer"
      class="expandPanel mt-4"
      expand
      v-model="cp_expanded"
    >
      <v-expansion-panel-content>
        <div slot="header">Select defaults Customer Parameters</div>
        <v-flex xs12 sm12 md12 xl12 px-4 py-2>
          <v-card flat>
            <integratedSearchBar
              :button_display="false"
              v-bind:search.sync="cp_search"
              search_label="Search customer parameters..."
            />
            <v-flex
              xs12
              px-4
              v-for="paramsGroup in customerParameterGroups"
              :key="paramsGroup.name"
            >
              <v-card
                pb-3
                flat
                v-if="
                  paramsGroup.customer_parameters.filter(
                    (cp) =>
                      !cp_search ||
                      cp.name.toLowerCase().includes(cp_search.toLowerCase())
                  ).length > 0
                "
              >
                <v-layout justify-end align-center>
                  <v-flex row wrap>
                    <div>{{ paramsGroup.name }}</div>
                  </v-flex>

                  <v-flex text-xs-right>
                    <v-btn
                      small
                      flat
                      @click="selectAllCustomerParameters(paramsGroup)"
                    >
                      <v-icon small>select_all</v-icon>Select all
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-container fluid pa-0>
                  <v-layout wrap row>
                    <v-flex
                      xs12
                      md6
                      lg4
                      pa-1
                      pl-3
                      style="cursor: pointer;"
                      class="hoverClass"
                      v-for="params in paramsGroup.customer_parameters.filter(
                        (cp) =>
                          !cp_search ||
                          cp.name
                            .toLowerCase()
                            .includes(cp_search.toLowerCase())
                      )"
                      :key="params.id"
                      @click="
                        updateCustomerParameters(
                          params.id,
                          !(
                            newCompany.customer.customer_parameter_ids &&
                            newCompany.customer.customer_parameter_ids.includes(
                              params.id
                            )
                          )
                        )
                      "
                    >
                      <v-checkbox
                        class="pb-1"
                        height="0"
                        :label="params.name"
                        :input-value="
                          newCompany.customer.customer_parameter_ids &&
                          newCompany.customer.customer_parameter_ids.includes(
                            params.id
                          )
                        "
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-card>
        </v-flex>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <collection
      class="pt-4"
      v-if="tempCompany.isCustomer && newCompany.isCustomer"
      formComponent="documentaryInstructionForm"
      resourceName="documentary_instructions"
      store="companyStore"
      :collectionHeaders="{ name: 'String', document_url: 'String' }"
    />

    <!-- Subsidirary Bank Informations -->
    <v-layout
      class="pt-2"
      justify-center
      wrap
      v-if="!newCompany.isSubsidiary && tempCompany.isSubsidiary"
    >
      <v-alert style="width: 100%;" :value="true" type="info">
        You need to save this company as a
        <strong>subsidiary</strong> in order to beeing able to access
        <strong>bank informations settings</strong> and
        <strong>signatures settings</strong>
      </v-alert>
    </v-layout>

    <collection
      v-if="tempCompany.isSubsidiary && newCompany.isSubsidiary"
      formComponent="bankInformationForm"
      resourceName="bank_informations"
      store="companyStore"
      :collectionHeaders="{
        name: 'String',
        beneficiary_bank: 'String',
        currency: 'commonResource',
        account_name: 'String',
      }"
      class="pt-2"
    />
    <!-- Subsidirary Signatures -->
    <v-card
      class="elevation-1 my-4"
      v-if="tempCompany.isSubsidiary && newCompany.isSubsidiary"
    >
      <v-card flat class="elevation-0 pb-0">
        <v-card-title class="pt-2 pb-0">
          <span class="primary--text text--capitalize">Signatures</span>
        </v-card-title>
        <v-container pa-3 grid-list-md>
          <v-layout wrap row fill-height>
            <v-flex
              pt-2
              xs4
              v-for="(signature, i) in settings.subsidiary.signatures"
              :key="'sign_' + i"
            >
              <uploader
                :id="signature.value"
                name="exp-12"
                v-on:s3url="
                  updateModel(
                    'companyStore',
                    ['newCompany', 'subsidiary'],
                    signature.value,
                    $event
                  )
                "
              />
              <v-text-field
                :label="signature.label"
                disabled
                :value="newCompany.subsidiary[signature.value]"
                background-color="#F4F4F5"
                box
                hide-details
              />
              <span
                style="
                  font-size: 11px;
                  color: #666;
                  position: relative;
                  top: 22px;
                  left: 12px;
                "
                >Preview:</span
              >
              <v-flex
                text-xs-center
                pa-2
                class="previewBox"
                style="height: 200px;"
                d-flex
              >
                <v-img
                  contain
                  v-if="newCompany.subsidiary[signature.value]"
                  :src="s3bucket + '/' + newCompany.subsidiary[signature.value]"
                  width="auto"
                  max-height="160px"
                  max-width="100%"
                ></v-img>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-card>

    <!-- <json-viewer :value="tempCompany"></json-viewer> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import integratedSearchBar from "../shared/integratedSearchBar";
import JsonViewer from "vue-json-viewer";
import collection from "../shared/collection";
import uploader from "../../components/shared/uploader";
import UPDATE_COMPANY from "../../graphql/companies/update.gql";
import CREATE_COMPANY from "../../graphql/companies/create.gql";

export default {
  components: {
    integratedSearchBar,
    collection,
    JsonViewer,
    uploader,
  },
  props: {
    // companyType: {
    //   type: String,
    //   required: true,
    // },
  },
  data() {
    return {
      editMode: false,
      errors: [],
      tempCompany: {},
      companyType: "",
      companyTypeIndex: -1,
      ai_expanded: [false],
      ai_search: "",
      ai_pagination: {
        descending: false,
        sortBy: "name",
        rowsPerPage: -1,
      },
      ai_headers: [
        {
          text: "",
          align: "left",
          value: "name",
        },
      ],

      cp_expanded: [false],
      cp_search: "",
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
      // s3bucket: "https://ctc-hatchbox-production.s3.sa-east-1.amazonaws.com",
    };
  },
  computed: {
    ...mapGetters("companyStore", ["newCompany"]),
    ...mapGetters("commonStore", [
      "supplier_types",
      "currencies",
      "shipments",
      "shippingCompanies",
      "countries",
      "ports",
      "paymentTerms",
      "incoterms",
      "additionalInformations",
      "additionalInformationsIds",
      "logisticAuditors",
      "customerParameterGroups",
      "getNameById",
    ]),
    settings() {
      return {
        supplier: {
          Infos: [
            {
              type: "autocomplete",
              label: "Supplier Type",
              alternate_label: "",
              multiple: false,
              icon: "local_offer",
              items: [this.supplier_types, "id", "name", "supplier_types"],
              value: "supplier_type_id",
              isFieldNeeded: "",
              tooltipHtml: "",
            },
            {
              type: "autocomplete",
              multiple: true,
              label: "Currencies",
              alternate_label: "",
              chips: true,
              icon: "mdi-cash",
              items: [this.currencies, "id", "name", "currencies"],
              value: "currency_ids",
              isFieldNeeded: "has_currencies",
              tooltipHtml: "",
            },
          ],
          "Shipment Settings": [
            {
              type: "autocomplete",
              label: "Country of origin (Products)",
              alternate_label: "",
              multiple: true,
              chips: true,
              icon: "mdi-flag",
              items: [this.countries, "id", "name", "countries"],
              value: "country_ids",
              isFieldNeeded: "has_origin_countries",
              tooltipHtml:
                "Countries in which the products have been produced.",
            },
            {
              type: "autocomplete",
              label: "POL (Port of Loading)",
              alternate_label: "",
              multiple: true,
              chips: true,
              icon: "mdi-boom-gate-down-outline",
              items: [this.ports, "id", "name", "ports"],
              value: "port_ids",
              isFieldNeeded: "has_ports",
              tooltipHtml: "",
            },
            {
              type: "autocomplete",
              multiple: true,
              label: "Shipping companies",
              alternate_label: "",
              chips: true,
              icon: "store",
              items: [this.shippingCompanies, "id", "name", "companies"],
              value: "shipping_company_ids",
              isFieldNeeded: "has_shipping_companies",
              tooltipHtml:
                "Shipping companies usually used from <strong>selected products origin.</strong>",
            },
            {
              type: "autocomplete",
              multiple: true,
              label: "Shipments",
              alternate_label: "",
              chips: true,
              icon: "mdi-view-dashboard-variant",
              items: [this.shipments, "id", "name", "shipments"],
              value: "shipment_ids",
              isFieldNeeded: "has_shipments",
              tooltipHtml: "",
            },
            {
              type: "textfield",
              multiple: false,
              label: "Tracking Url for BL",
              alternate_label: "Exemple: https://www.site.com/id={{reference}}",
              icon: "mdi-link-variant",
              items: "",
              value: "shipping_tracking_url_bl",
              isFieldNeeded: "has_shipping_tracking_url",
              tooltipHtml:
                "Shipping line's tracking url for BL.<br />Write the full URL and put {{reference}} where the reference ID is for interpolation",
            },
            {
              type: "textfield",
              multiple: false,
              label: "Tracking Url for Booking",
              alternate_label: "Exemple: https://www.site.com/id={{reference}}",
              icon: "mdi-link-variant",
              items: "",
              value: "shipping_tracking_url_booking",
              isFieldNeeded: "has_shipping_tracking_url",
              tooltipHtml:
                "Shipping line's tracking url for Booking.<br />Write the full URL and put {{reference}} where the reference ID is for interpolation",
            },
            {
              type: "textfield",
              multiple: false,
              label: "Tracking Url for a Shipment Unit",
              alternate_label: "Exemple: https://www.site.com/id={{reference}}",
              icon: "mdi-link-variant",
              items: "",
              value: "shipping_tracking_url_shipment_unit",
              isFieldNeeded: "has_shipping_tracking_url",
              tooltipHtml:
                "Shipping line's tracking url for Shipment unit.<br />Write the full URL and put {{reference}} where the reference ID is for interpolation",
            },
          ],
          Incoterms: [
            {
              type: "autocomplete",
              multiple: true,
              label: "Payment terms",
              alternate_label: "",
              chips: true,
              icon: "mdi-file-document",
              items: [this.paymentTerms, "id", "name", "payment_terms"],
              value: "payment_term_ids",
              isFieldNeeded: "has_payment_terms",
              tooltipHtml: "",
            },
            {
              type: "autocomplete",
              multiple: true,
              label: "Incoterms",
              alternate_label: "",
              chips: true,
              icon: "mdi-file-document",
              items: [this.incoterms, "id", "name", "incoterms"],
              value: "incoterm_ids",
              isFieldNeeded: "has_incoterms",
              tooltipHtml: "",
            },
          ],
        },
        customer: {
          Infos: [
            {
              type: "autocomplete",
              multiple: true,
              label: "Currencies",
              alternate_label: "",
              chips: true,
              icon: "mdi-cash",
              items: [this.currencies, "id", "name", "currencies"],
              value: "currency_ids",
              isFieldNeeded: "",
              tooltipHtml: "",
            },
          ],
          "Shipment Settings": [
            {
              type: "autocomplete",
              label: "Countries of destination (Products)",
              alternate_label: "",
              multiple: true,
              chips: true,
              icon: "mdi-flag",
              items: [this.countries, "id", "name", "countries"],
              value: "country_ids",
              isFieldNeeded: "",
              tooltipHtml: "Countries in which the products will be shipped.",
            },
            {
              type: "autocomplete",
              label: "POD (Port of Destination)",
              alternate_label: "",
              multiple: true,
              chips: true,
              icon: "mdi-boom-gate-up-outline",
              items: [this.ports, "id", "name", "ports"],
              value: "port_ids",
              isFieldNeeded: "",
              tooltipHtml: "",
            },
            {
              type: "autocomplete",
              multiple: true,
              label: "Unwanted Shipping companies",
              alternate_label: "",
              chips: true,
              icon: "mdi-minus-circle",
              items: [this.shippingCompanies, "id", "name", "companies"],
              value: "company_ids",
              isFieldNeeded: "",
              tooltipHtml:
                " Shipping companies <strong>NOT</strong> allowed to load with for this Customer.",
            },
          ],
          Incoterms: [
            {
              type: "autocomplete",
              multiple: true,
              label: "Payment terms",
              alternate_label: "",
              chips: true,
              icon: "mdi-file-document",
              items: [this.paymentTerms, "id", "name", "payment_terms"],
              value: "payment_term_ids",
              isFieldNeeded: "",
              tooltipHtml: "",
            },
            {
              type: "autocomplete",
              multiple: true,
              label: "Incoterms",
              alternate_label: "",
              chips: true,
              icon: "mdi-file-document",
              items: [this.incoterms, "id", "name", "incoterms"],
              value: "incoterm_ids",
              isFieldNeeded: "",
              tooltipHtml: "",
            },
          ],
          Misc: [
            {
              type: "autocomplete",
              multiple: true,
              label: "Logistic Auditors",
              alternate_label: "",
              chips: true,
              icon: "mdi-book-search",
              items: [this.logisticAuditors, "id", "name", "companies"],
              value: "logistic_auditor_ids",
              isFieldNeeded: "",
              tooltipHtml: "",
            },
          ],
        },
        subsidiary: {
          signatures: [
            {
              label: "Signed stamp",
              value: "actual_stamp",
            },
            {
              label: "Stamp without signature",
              value: "stamp_without_signature",
            },
            {
              label: "Digital Signature",
              value: "digital_signature",
            },
          ],
        },
      };
    },
  },

  methods: {
    missingField() {
      return false;
    },
    getCompanyTypeIndex() {
      if (this.tempCompany.isSupplier) return 0;
      if (this.tempCompany.isCustomer) return 1;
      if (this.tempCompany.isSubsidiary) return 2;
      return -1;
    },
    aiUpdate(item_id, value) {
      let list = this.newCompany.supplier.additional_information_ids;
      if (value == true) list = list.concat(item_id);
      else
        list = list.filter((e) => {
          return e !== item_id;
        });
      this.updateModel(
        "companyStore",
        ["newCompany", "supplier"],
        "additional_information_ids",
        list
      );
    },
    displayModel(field_needed) {
      return field_needed ? this.isFieldNeeded(field_needed) : true;
    },
    isFieldNeeded(boolean_name) {
      if (!this.tempCompany.isSupplier) return false;
      if (!this.tempCompany.supplier.supplier_type_id) return false;

      let supplier_type = this.supplier_types.find(
        (e) => e.id === this.tempCompany.supplier.supplier_type_id
      );
      return supplier_type[boolean_name];
    },
    selectAllCustomerParameters(group) {
      let contain_all_group_ids = true;
      const ids = group.customer_parameters
        .filter(
          (cp) =>
            !this.cp_search ||
            cp.name.toLowerCase().includes(this.cp_search.toLowerCase())
        )
        .map((e) => {
          return e.id;
        });

      const oldIds = this.newCompany.customer.customer_parameter_ids.filter(
        (e) => {
          return !ids.includes(e);
        }
      );

      ids.forEach((e) => {
        if (!this.newCompany.customer.customer_parameter_ids.includes(e))
          contain_all_group_ids = false;
      });

      const idsToSelect = contain_all_group_ids ? oldIds : ids.concat(oldIds);
      this.updateModel(
        "companyStore",
        ["newCompany", "customer"],
        "customer_parameter_ids",
        idsToSelect
      );
    },
    truncate(input, size) {
      if (input.length > size) return input.substring(0, size) + "...";
      else return input;
    },
    updateCustomerParameters(item_id, value) {
      const list =
        value == true
          ? this.newCompany.customer.customer_parameter_ids.concat(item_id)
          : this.newCompany.customer.customer_parameter_ids.filter((e) => {
              return e !== item_id;
            });
      this.updateModel(
        "companyStore",
        ["newCompany", "customer"],
        "customer_parameter_ids",
        list
      );
    },
    save() {
      if (this.tempCompany.isSupplier) {
        this.tempCompany.supplier_attributes = this.tempCompany.supplier;
      }
      if (this.tempCompany.isCustomer) {
        this.tempCompany.customer_attributes = this.tempCompany.customer;
      }
      if (this.tempCompany.isSubsidiary) {
        this.tempCompany.subsidiary_attributes = this.tempCompany.subsidiary;
      }

      if (this.tempCompany.subsidiary) {
        delete this.tempCompany.subsidiary.bank_informations;
      }
      if (this.tempCompany.customer) {
        delete this.tempCompany.customer.documentary_instructions;
      }

      delete this.tempCompany.subsidiary.id;
      delete this.tempCompany.supplier.id;
      delete this.tempCompany.customer.id;
      // var self = this;
      if (this.tempCompany.id) {
        this.sendMutation(
          "update",
          "company",
          UPDATE_COMPANY,
          this.tempCompany
        ).then(() => {
          this.editMode = false;
          //  this.newCompany = JSON.parse(JSON.stringify(this.tempCompany));
        });
        // .catch(error => {
        //   self.errors = [];
        //   error.networkError.result.errors.forEach((e) => {
        //     self.errors = e.message.split(", ");
        //   });
        //   self.errors = self.errors.map(e => e.replace(" are needed","").replace(/ /g,"_").toLowerCase() );
        //   console.log("errors", self.errors)
        // });
      } else {
        this.sendMutation(
          "create",
          "company",
          CREATE_COMPANY,
          this.tempCompany
        ).then(() => {
          this.editMode = false;
          //  this.newCompany = JSON.parse(JSON.stringify(this.tempCompany));
        });
      }
    },
    cancel() {
      // Reset form to old values
      this.resetTempCompany();
      this.editMode = false;
    },
    resetTempCompany() {
      this.tempCompany = JSON.parse(JSON.stringify(this.newCompany));
      this.companyTypeIndex = this.getCompanyTypeIndex();
      this.updateCompanyType(this.companyTypeIndex);
    },
    updateCompanyType(index) {
      this.tempCompany.isSupplier = false;
      this.tempCompany.isCustomer = false;
      this.tempCompany.isSubsidiary = false;
      if (index == 0) {
        this.tempCompany.isSupplier = true;
      }
      if (index == 1) {
        this.tempCompany.isCustomer = true;
      }
      if (index == 2) {
        this.tempCompany.isSubsidiary = true;
      }
      this.companyType = ["supplier", "customer", "subsidiary"][index];
      if (index == -1) this.companyType = "";
    },
  },
  watch: {
    companyTypeIndex() {
      if (this.tempCompany) this.updateCompanyType(this.companyTypeIndex);
    },
  },
  created() {
    this.resetTempCompany();
  },
};
</script>

<style lang="stylus" scoped>
.dense-input >>> .v-input__control {
  min-height: 28px !important;
  height: 28px !important;
  font-size: 14px;
}

.hoverClass:hover {
  background-color: #eee;
}

.previewBox {
  border-width: 2px;
  border-style: dashed;
  border-color: rgba(0, 0, 0, 0.1);
}
</style>
